import styled from '@emotion/styled';
import { getStaticImageUrl } from '@utils/createImageUrl';
import media from '@shared/mediaQuery';

const PreviewStyle = styled('div')`
  position: relative;
  background-color: #fff;
  .sticky-elem {
    display: none;
    position: fixed;
    left: 0;
    width: 100%;
  }

  .for-lawyer__top-banner-container {
    position: relative;
    height: 100vh;
    width: 100%;
    &.sticky {
      .for-lawyer__top-banner-content {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .for-lawyer__top-banner-content {
    background-image: url(${getStaticImageUrl({ fileName: 'preview/main_mobile.jpg' })});
    ${media.desktop} {
      background-image: url(${getStaticImageUrl({ fileName: 'preview/main_mobile-desktop.jpg' })});
    }

    background-repeat: no-repeat;
    background-size: cover;
    height: 100vh;
    width: 100%;
    position: relative;
    &.invisible-background {
      background: none;
    }
    .for-lawyer-top-banner-vlog__title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      display: block;
      ${media.mobile} {
        bottom: 28%;
      }
      ${media.desktop} {
        bottom: 157px;
      }
      &.invisible {
        display: none;
      }
      .for-lawyer-top-banner-vlog {
        width: 232.8px;
        height: 118.5px;
        ${media.desktop} {
          width: 368.5px;
          height: 187.5px;
        }
      }
      .for-lawyer-top-banner-vlog-title {
        font-family: 'Pretendard-Bold';
        font-size: 20px;
        color: #fff;
        left: 50%;
        position: absolute;
        transform: translateX(-68%);
        top: 98px;
        ${media.desktop} {
          width: 300px;
          font-size: 28px;
          transform: translateX(21%);
          top: 26px;
        }
      }
    }
  }
  .for-lawyer-mobile-profile-image {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    ${media.mobile} {
      background-image: url(${getStaticImageUrl({ fileName: 'preview/mobile-profile.png' })});
    }
    ${media.desktop} {
      background-image: url(${getStaticImageUrl({ fileName: 'preview/desktop-profile.jpg' })});
    }
    &.active {
      opacity: 1;
      transition: opacity 200ms linear;
    }
  }
  .for-lawyer-mobile-profile-price-image {
    position: absolute;
    top: 0;
    left: 0;
    background-image: url(${getStaticImageUrl({ fileName: 'preview/mobile-profile-price.png' })});
    opacity: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    ${media.desktop} {
      background-image: url(${getStaticImageUrl({ fileName: 'preview/desktop-profile-price.jpg' })});
    }
    &.active {
      opacity: 1;
      transition: opacity 200ms linear;
    }
  }
  .for-lawyer-mobile-profile-price-law-image {
    position: absolute;
    left: -14px;
    background-image: url(${getStaticImageUrl({ fileName: 'preview/mobile-profile-price-law.png' })});
    opacity: 0;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    width: 244px;

    ${media.desktop} {
      width: 100%;
      background-image: url(${getStaticImageUrl({ fileName: 'preview/desktop-profile-price-law.jpg' })});
    }
    &.active {
      opacity: 1;
      transition: opacity 200ms linear;
    }
  }
  .for-lawyer-dayplus-title {
    position: relative;
    margin-top: -14px;
    ${media.desktop} {
      margin-top: -90px;
    }
    .for-lawyer-day-title {
      font-family: 'Gilroy-ExtraBold';
      font-size: 70px;
      color: #222;
      ${media.desktop} {
        font-size: 130px;
      }
      &.white {
        color: #fff;
      }
    }
    .for-lawyer-day-plus-number-title {
      font-family: 'Gilroy-ExtraBold';
      font-size: 30px;
      color: #ff5500;
      position: absolute;
      top: 26px;
      left: 155px;
      &.white {
        color: #fff;
      }
      ${media.desktop} {
        font-size: 60px;
        top: 45px;
        left: 270px;
      }
    }
  }

  .view-on-visible {
    opacity: 0;
    transform: translateY(50px);
    transition: transform 1s ease-in-out, opacity 1s ease-in-out;
    &.visible {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .for-lawyer-day-desc {
    margin-top: 6px;
    font-family: 'Pretendard-Regular';
    font-size: 16px;
    color: #555;
    line-height: 26px;
    ${media.desktop} {
      font-size: 24px;
      line-height: 40px;
    }
    .for-lawyer-day-desc-bold {
      font-family: 'Pretendard-Bold';
      font-size: 16px;
      color: #555;
      line-height: 26px;
      ${media.desktop} {
        font-size: 24px;
        line-height: 40px;
      }
      &-mobile {
        ${media.mobile} {
          font-family: 'Pretendard-Bold';
          font-size: 16px;
          color: #555;
          line-height: 26px;
        }
      }
    }
    &.white {
      color: #fff;
      .for-lawyer-day-desc-bold {
        color: #fff;
      }
    }
  }

  .for-lawyer__slide-circle-container {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-56%);
    gap: 17px;
    ${media.desktop} {
      right: 50%;
      transform: translate(500px, -56%);
    }
    .for-lawyer__slide-circle {
      width: 9px;
      height: 9px;
      background-color: #e0e0e0;
      border-radius: 50%;
      &.active {
        background-color: #757575;
      }
      &.white {
        background-color: #fff;
        opacity: 0.5;
        &.active {
          opacity: 1;
        }
      }
    }
  }

  section.for-lawyer__oneday {
    position: relative;
    .for-lawyer__oneday-content {
      width: 100%;
      height: 100vh;
      ${media.desktop} {
        display: flex;
        align-items: center;
      }
      &.active {
        position: fixed;
        top: 0;
        left: 0;
      }
      &.bottom-active {
        position: absolute;
        bottom: 0;
        left: 0;
        top: unset;
      }
    }
    .for-lawyer__oneday-content-center {
      ${media.mobile} {
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        max-width: 335px;
        width: calc(100% - 40px);
        position: relative;
      }
      ${media.desktop} {
        margin: 0 auto;
        position: relative;
      }
    }

    .for-lawyer-dayplus-title {
      ${media.desktop} {
        position: absolute;
        bottom: 139px;
        right: 129px;
      }
    }
    .for-lawyer-day-desc {
      ${media.desktop} {
        width: 660px;
        margin: 108px auto 0;
      }
    }
    .for-lawyer-oneday-device-img {
      width: 215px;
      height: 441px;
      margin: 0 auto;
      ${media.mobile} {
        box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.2);
        border-radius: 16px;
      }
      ${media.desktop} {
        width: 940px;
        height: 609px;
      }
    }
    .for-lawyer__slide-circle-container {
      ${media.desktop} {
        right: 50%;
        transform: translate(500px, -184%);
      }
    }
  }

  section.for-lawyer__empty-lawyer-image {
    padding-top: 67px;
    .for-lawyer__empty-lawyer-image-card {
      width: 375px;
      height: 279px;
      margin: 0 auto;
      display: block;
      ${media.desktop} {
        width: 749px;
        height: 442px;
        margin-top: 167px;
      }
    }
    .for-lawyer__empty-lawyer-image-desc-container {
      ${media.mobile} {
        width: calc(100% - 40px);
        max-width: 335px;
        margin: 49px auto 0;
      }
      ${media.desktop} {
        width: 660px;
        margin: 41px auto 0;
      }
    }
    .for-lawyer__empty-lawyer-image-desc {
      ${media.mobile} {
        width: 255px;
        height: 38px;
      }
      ${media.desktop} {
        width: 468px;
        height: 68px;
      }
    }
  }

  @keyframes animateBubble {
    0% {
      margin-top: 20px;
    }
    50% {
      margin-top: 0;
    }
    100% {
      margin-top: 20px;
    }
  }

  @keyframes downAnimateBubble {
    0% {
      margin-top: -20px;
    }
    50% {
      margin-top: 0;
    }
    100% {
      margin-top: -20px;
    }
  }

  section.for-lawyer__lawyer-image {
    position: relative;
    overflow: hidden;
    ${media.mobile} {
      height: 460px;
    }
    ${media.desktop} {
      height: 920px;
    }
    .for-lawyer-image {
      position: absolute;
      left: 50%;
    }
    .for-lawyer-top-image {
      animation: animateBubble 3s linear infinite;
      ${media.mobile} {
        transform: translateX(10%) scale(0.65);
      }
      ${media.desktop} {
        top: 142px;
        transform: translateX(35%);
      }
    }
    .for-lawyer-middle-image {
      top: 46px;
      animation: downAnimateBubble 3s linear infinite;
      ${media.mobile} {
        transform: translateX(-64%) scale(0.56);
      }
      ${media.desktop} {
        top: 246px;
        transform: translateX(-82%);
      }
    }
    .for-lawyer-bottom-image {
      animation: animateBubble 3s linear infinite;
      ${media.mobile} {
        top: 163px;
        transform: translateX(-22%) scale(0.57);
      }
      ${media.desktop} {
        top: 506px;
        transform: translateX(-5%);
      }
    }
    .for-lawyer-day-desc {
      ${media.mobile} {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 40px);
        max-width: 335px;
      }
      ${media.desktop} {
        width: 660px;
        margin: 30px auto 0;
      }
    }
  }

  section.for-lawyer__fourteen-day {
    margin: 0 auto;
    padding-top: 187px;
    padding-bottom: 95px;
    ${media.mobile} {
      width: 335px;
      padding-top: 315px;
    }
    .for-lawyer-advice-phone-noti {
      display: block;
      width: 335px;
      height: 100px;
      ${media.desktop} {
        width: 740px;
        height: 277px;
        margin: 0 auto;
      }
    }
    .for-lawyer-dayplus-title {
      margin-top: 39px;
      ${media.desktop} {
        width: 660px;
        margin: 16px auto;
      }
    }
    .for-lawyer-day-desc {
      ${media.desktop} {
        width: 660px;
        margin: 0 auto;
      }
    }
    .number-title {
      left: 135px;
    }
  }

  .for-lawyer__advice-back {
    ${media.mobile} {
      background-image: url(${getStaticImageUrl({ fileName: 'preview/cloud.jpg' })});
      background-repeat: no-repeat;
      background-position: bottom;
      background-size: 428px auto;
      background-color: #fff;
    }
    ${media.desktop} {
      background-repeat: no-repeat;
      background-position: center 392px;
      background-image: url(${getStaticImageUrl({ fileName: 'preview/advice-list-desktop.jpg' })});
    }
  }
  section.for-lawyer__advice {
    position: relative;
    .for-lawyer__advice-content {
      background-repeat: no-repeat;
      height: 100vh;
      ${media.mobile} {
        background-position: top;
        background-image: url(${getStaticImageUrl({ fileName: 'preview/advice-list-mobile.jpg' })});
        background-color: #111;
      }
      ${media.desktop} {
        background-position: center -1518px;
        /* background-position: center 63%; */
        background-image: url(${getStaticImageUrl({ fileName: 'preview/advice-list-desktop.jpg' })});
      }
      &.fixed {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
      }
      &.fixed-none {
        position: absolute;
        top: unset;
        bottom: 0;
        left: 0;
      }
    }
    .for-lawyer-advice-step-image {
      .for-lawyer-advice-step-img {
        position: absolute;
        left: 50%;
        transform: translateX(-51.5%);
        top: 77px;
        width: 248px;
        height: 398px;
        opacity: 0;
        ${media.desktop} {
          width: 375px;
          height: 599px;
          transform: translateX(-44.5%);
          top: 111px;
        }
        &.active {
          opacity: 1;
          transition: opacity 200ms linear;
        }
      }
    }
    .for-lawyer-advice-step-desc-container {
      .for-lawyer-advice-step-desc {
        position: absolute;
        width: 100%;
        left: 50%;
        top: 510px;
        transform: translateX(-50%);
        padding: 6px 9px;
        background-color: #000;
        font-family: 'Pretendard-Regular';
        font-size: 16px;
        color: #fff;
        line-height: 24px;
        width: calc(100% - 40px);
        margin: 0 auto;
        opacity: 0;
        text-align: center;
        ${media.mobile} {
          max-width: 335px;
        }
        ${media.desktop} {
          width: 660px;
          font-size: 24px;
          line-height: 38px;
          box-sizing: border-box;
          padding: 13px 9px;
          top: 840px;
        }
        &.active {
          opacity: 1;
          transition: opacity 200ms linear;
        }
      }
    }
  }

  section.for-lawyer__thirty-day {
    background-color: #111;
    position: relative;
    ${media.desktop} {
      padding-top: 489px;
    }
    .for-lawyer__thirty-day-content-container {
      display: flex;
      align-items: center;
      width: 100%;
      ${media.desktop} {
        justify-content: center;
      }
      ${media.mobile} {
        box-sizing: border-box;
        height: 100vh;
      }
      &.fixed {
        position: fixed;
        top: 0;
        left: 0;
      }
      &.fixed-none {
        position: absolute;
        bottom: 0;
        left: 0;
        top: unset;
      }
      .for-lawyer__thirty-day-content {
        ${media.mobile} {
          width: calc(100% - 40px);
          max-width: 335px;
          margin: 0 auto;
        }
        ${media.desktop} {
          width: 660px;
        }
      }
    }
    .for-lawyer__thirty-day-title-container {
      ${media.desktop} {
        width: 660px;
        margin: 0 auto;
      }
    }
    .for-lawyer-day-desc {
      ${media.desktop} {
        margin-top: 16px;
      }
    }
    .for-lawyer-ad-type-img-container {
      ${media.mobile} {
        position: relative;
        height: 293px;
      }
      ${media.desktop} {
        display: flex;
        justify-content: center;
        margin-top: 52px;
      }
      .for-lawyer-ad-type-img {
        opacity: 0;
        ${media.mobile} {
          width: 254px;
          height: 293px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        }

        &.active {
          opacity: 1;
          transition: opacity 200ms linear;
        }
        &.for-lawyer-ad-type-img-1 {
          ${media.mobile} {
            width: 287.5px;
            height: 313.8px;
          }
          ${media.desktop} {
            width: 349.8px;
            height: 381.5px;
          }
        }
        &.for-lawyer-ad-type-img-2 {
          ${media.mobile} {
            width: 334px;
            height: 317px;
          }
          ${media.desktop} {
            width: 406.5px;
            height: 386px;
            margin-left: -38px;
          }
        }
      }
    }
  }

  section.for-lawyer__ad-desc {
    background-color: #111;
    position: relative;
    ${media.mobile} {
      padding: 80px 20px 120px;
      overflow: hidden;
      box-sizing: border-box;
    }
    ${media.desktop} {
      padding-top: 68px;
    }
    .for-lawyer__ad-desc-content {
      ${media.mobile} {
        height: 242px;
      }
      ${media.desktop} {
        height: 350px;
        width: 660px;
        margin: 0 auto;
      }
    }
    .for-lawyer-day-desc {
      ${media.mobile} {
        z-index: 2;
        width: calc(100% - 40px);
        position: absolute;
        max-width: 335px;
        left: 50%;
        transform: translateX(-48%);
      }
      ${media.desktop} {
        margin: 0;
      }
    }
    .for-lawyer-call-three-circle-image {
      position: absolute;
      ${media.mobile} {
        z-index: 0;
        top: 160px;
        left: 50%;
        transform: translateX(31%);
        width: 150px;
        height: 150px;
      }
      ${media.desktop} {
        right: 37px;
        top: 5px;
        width: 300px;
        height: 300px;
      }
    }
    .for-lawyer-phone-ring-image {
      position: absolute;
      ${media.mobile} {
        width: 200px;
        height: 200px;
        top: 270px;
        left: 50%;
        z-index: 0;
        transform: translateX(-21%);
      }
      ${media.desktop} {
        right: 160px;
        top: 162px;
        width: 400px;
        height: 400px;
      }
    }
  }

  section.for-lawyer__thirty-five-day {
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-color: #111;
    ${media.mobile} {
      padding: 100px 0px 700px;
      background-image: url(${getStaticImageUrl({ fileName: 'preview/advice-background.jpg' })});
      background-position: center 260px;
    }
    ${media.desktop} {
      padding: 569px 0 520px;
      background-image: url(${getStaticImageUrl({ fileName: 'preview/advice-background-desktop.jpg' })});
      background-position: center 781px;
    }
    .for-lawyer-advice-before-three-hour-noti {
      display: block;
      margin: 0 auto;
      ${media.mobile} {
        width: 335px;
        height: 100px;
      }
      ${media.desktop} {
        width: 660px;
        height: 197px;
      }
    }
    .for-lawyer-dayplus-title-container {
      ${media.desktop} {
        width: 660px;
        margin: 0 auto;
      }
      ${media.mobile} {
        width: calc(100% - 40px);
        max-width: 335px;
        margin: 0 auto;
      }
    }
    .for-lawyer-dayplus-title {
      margin-top: 38px;
    }
  }

  section.for-lawyer__advice-schedule {
    background-color: #111;
    ${media.mobile} {
      padding: 10px 0px 113px;
    }
    ${media.desktop} {
      padding-bottom: 200px;
    }
    .for-lawyer-day-desc {
      ${media.desktop} {
        margin: 0 auto;
        width: 660px;
      }
      ${media.mobile} {
        margin: 0 auto;
        width: calc(100% - 40px);
        max-width: 335px;
      }
    }
    .for-lawyer-advice-mobile {
      width: 215px;
      height: 441px;
      margin: 0 auto;
      margin-top: 38px;
      position: relative;
      overflow: hidden;
      ${media.desktop} {
        width: 306px;
        height: 630px;
      }
      &.visible {
        .for-lawyer-manager-schedule-img {
          right: -30px;
          transition: right 1s ease-out 1s;
          ${media.desktop} {
            right: -43.5px;
          }
        }
      }
      .for-lawyer-manager-splash-img {
        width: 215px;
        height: 441px;
        ${media.desktop} {
          width: 306px;
          height: 630px;
        }
      }
      .for-lawyer-manager-schedule-img {
        width: 275px;
        height: 501px;
        position: absolute;
        top: -17px;
        right: -275px;
        ${media.desktop} {
          width: 393px;
          height: 716.2px;
          top: -29px;
          right: -393px;
        }
        &.fixed {
          position: fixed;
          top: 80px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 1;
        }
      }
    }
  }

  section.for-lawyer__advice-after {
    ${media.mobile} {
      position: relative;
    }
    ${media.desktop} {
      padding: 200px 0;
    }
    .for-lawyer__advice-after-content-container {
      ${media.mobile} {
        height: 100vh;
        display: flex;
        align-items: center;
        &.fixed {
          width: 100%;
          position: fixed;
          top: 0;
          left: 0;
        }
        &.fixed-none {
          position: absolute;
          top: unset;
          bottom: 0;
          left: 0;
        }
      }
      ${media.desktop} {
        width: 660px;
        margin: 0 auto;
      }
      .for-lawyer__advice-after-content {
        ${media.mobile} {
          position: relative;
          width: calc(100% - 40px);
          max-width: 335px;
          margin: 0 auto;
        }
        .for-lawyer__advice-after-images {
          position: relative;
          ${media.mobile} {
            height: 441px;
          }
          ${media.desktop} {
            height: 716px;
          }
          .for-lawyer__advice-after-image {
            position: absolute;
            top: 0;
            ${media.mobile} {
              left: 50%;
              transform: translateX(-50%);
              opacity: 0;
              ${media.mobile} {
                width: 275px;
                height: 501px;
              }
              &.active {
                opacity: 1;
                transition: opacity 200ms linear;
              }
            }
            ${media.desktop} {
              width: 393px;
              height: 716px;
              left: 50%;
              &.for-lawyer-advice-list-img {
                transform: translateX(-50%);
              }
              &.for-lawyer-advice-review-img {
                transform: translateX(36%);
              }
            }
          }
        }
      }
      .for-lawyer-dayplus-title {
        ${media.desktop} {
          margin-top: -90px;
        }
      }
      .for-lawyer-day-desc {
        ${media.desktop} {
          margin-top: 18px;
        }
      }
    }
  }

  .for-lawyer__guide {
    background-color: #f6f6f6;
    ${media.mobile} {
      padding: 100px 20px 60px;
    }
    ${media.desktop} {
      padding: 200px 0px;
    }
    ul {
      padding: 0;
      margin: 0;
    }
    .for-lawyer__guide-1,
    .for-lawyer__guide-2,
    .for-lawyer__guide-3,
    .for-lawyer__guide-4 {
      ${media.desktop} {
        width: 940px;
        margin: 0 auto;
      }
    }

    .for-lawyer__guide-sub-title {
      font-family: 'Pretendard-Bold';
      color: #f50;
      font-size: 13px;
      margin-bottom: 3px;
      ${media.desktop} {
        font-size: 24px;
        line-height: 38.5px;
      }
    }

    .for-lawyer__guide-title {
      font-family: 'Pretendard-Bold';
      font-size: 24px;
      color: #222;
      line-height: 34px;
      ${media.desktop} {
        font-size: 48px;
        line-height: 60px;
      }
    }

    .for-lawyer__ad {
      ${media.mobile} {
        margin-top: 30px;
      }
      ${media.desktop} {
        margin-top: 58px;
      }
      &.for-lawyer__ad-use {
        margin-top: 22px;
      }
      .for-lawyer__ad-title {
        font-family: 'Pretendard-Bold';
        font-size: 16px;
        color: #222;
        ${media.desktop} {
          font-size: 28px;
          line-height: 38.5px;
        }
      }

      .for-lawyer__ad-step-container {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 13px;
        ${media.desktop} {
          width: 900px;
          margin-top: 22px;
        }
        .for-lawyer__ad-step {
          background-color: #eaeaea;
          padding: 5px 9px 4px;
          font-family: 'Pretendard-Regular';
          font-size: 14px;
          color: #555;
          line-height: 22px;
          margin-bottom: 7px;
          border-radius: 4px;
          ${media.desktop} {
            font-size: 18px;
            padding: 8px 15px;
            margin-bottom: 16px;
          }
          &.highlight-step {
            background-color: #f50;
            color: #fff;
          }
        }
        .for-lawyer__ad-step-arrow {
          transform: rotate(-90deg);
          margin-left: 2px;
          margin-top: -8px;
          margin-right: 6px;
          ${media.desktop} {
            margin-top: -16px;
            margin-right: 9px;
          }
        }
      }
    }

    .for-lawyer__guide-2 {
      ${media.mobile} {
        margin-top: 100px;
      }
      ${media.desktop} {
        margin-top: 187px;
      }
      .for-lawyer__guide-title {
        ${media.mobile} {
          margin-bottom: 30px;
        }
        ${media.desktop} {
          margin-bottom: 57px;
        }
      }
      .for-lawyer-use-container {
        ${media.desktop} {
          display: flex;
          .for-lawyer-use {
            width: 50%;
            flex: none;
            box-sizing: border-box;
          }
        }
      }
      .for-lawyer-use {
        padding: 30px 20px;
        background-color: #fff;
        ${media.desktop} {
          padding: 55px 52px 49px;
        }
        &.for-lawyer-after-use {
          border: 2px solid #f50;
          ${media.desktop} {
            border: 3px solid #f50;
          }
        }
        .for-lawyer-before-use-title {
          font-family: 'Pretendard-Bold';
          font-size: 16px;
          color: #757575;
          line-height: 20px;
          ${media.desktop} {
            font-size: 28px;
            line-height: 27px;
          }
        }

        .for-lawyer-before-use-list {
          margin-top: 8px;
          margin-left: 5px;
          ${media.desktop} {
            margin-top: 11px;
          }
          .for-lawyer-before-use-list-item {
            font-family: 'Pretendard-Regular';
            font-size: 14px;
            line-height: 22px;
            color: #757575;
            position: relative;
            padding-left: 15px;
            list-style: none;
            ${media.desktop} {
              font-size: 18px;
              line-height: 34px;
              padding-left: 23px;
            }
            &:before {
              content: '';
              width: 4px;
              height: 4px;
              border-radius: 50%;
              background-color: #757575;
              position: absolute;
              top: 10px;
              left: 5px;
              ${media.desktop} {
                width: 6px;
                height: 6px;
                top: 15px;
                left: 6px;
              }
            }
          }
        }
        .for-lawyer-after-use-title {
          font-family: 'Pretendard-Bold';
          font-size: 16px;
          color: #333;
          line-height: 20px;
          ${media.desktop} {
            font-size: 28px;
            line-height: 27px;
          }
        }
      }
    }
    .for-lawyer-after-use-list {
      margin-top: 2px;
      ${media.desktop} {
        margin-top: 8px;
      }
    }

    .for-lawyer-after-use-list-item {
      font-family: 'Pretendard-Regular';
      font-size: 14px;
      color: #333;
      line-height: 22px;
      padding-left: 15px;
      position: relative;
      list-style: none;
      ${media.desktop} {
        font-size: 18px;
        line-height: 34px;
        padding-left: 24px;
      }
      &:before {
        content: '';
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #333;
        position: absolute;
        top: 10px;
        left: 5px;
        ${media.desktop} {
          width: 6px;
          height: 6px;
          top: 15px;
          left: 6px;
        }
      }
      .for-lawyer-after-use-list-item-bold {
        font-family: 'Pretendard-Bold';
      }
    }

    .for-lawyer__guide-3 {
      margin-top: 100px;
      ${media.desktop} {
        margin-top: 198px;
      }
      .for-lawyer__guide-title {
        margin-bottom: 21px;
      }
      .for-lawyer-after-use-list {
        margin-left: 10px;
        ${media.desktop} {
          margin-left: 5px;
          margin-top: 31px;
          width: 750px;
        }
      }
      .reservation-container {
        margin-top: 20px;
        ${media.desktop} {
          margin-top: 56px;
          .whattime-inline-widget {
            width: 940px;
            height: 700px;
          }
        }
      }
    }

    .for-lawyer__guide-4 {
      margin-top: 100px;
      ${media.desktop} {
        margin-top: 197px;
      }
      .for-lawyer-guide-links {
        margin-top: 6px;
        ${media.desktop} {
          margin-top: 29px;
        }
        .for-lawyer-guide-link {
          text-decoration: none;
          font-size: 14px;
          font-family: 'Pretendard-Bold';
          line-height: 20px;
          padding: 23px 0 22px;
          border-bottom: 1px solid #d7d7d7;
          display: block;
          color: #333;
          position: relative;
          width: 100%;
          text-align: left;
          ${media.desktop} {
            font-size: 24px;
            line-height: 34px;
            padding: 30px 0 29px;
          }
          .arrow-icon {
            position: absolute;
            right: 0;
            top: 23px;
            ${media.desktop} {
              right: 30px;
              top: 34px;
            }
          }
        }
      }
    }
  }

  @keyframes moveArrow {
    0% {
      bottom: 40px;
    }
    50% {
      bottom: 50px;
    }
    100% {
      bottom: 40px;
    }
  }

  .for-lawyer__footer {
    padding: 0 20px 30px;
    background-color: #f6f6f6;

    &-copyright {
      color: #999;
      font-size: 11px;
    }
    .for-lawyer__footer-content {
      ${media.desktop} {
        width: 940px;
        margin: 0 auto;
      }
    }
  }
  .for-lawyer-fix-arrow {
    position: fixed;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);

    &.move-arrow {
      animation: moveArrow 1s linear infinite;
    }

    .for-lawyer-fix-arrow-icon {
      border: solid #fff;
      border-width: 0 1px 1px 0;
      display: inline-block;
      padding: 9px;
      transform: rotate(45deg);
      &.active-scroll {
        border-color: #f50;
      }
    }
    .for-lawyer-fix-arrow-circle {
      position: absolute;
      top: -86px;
      left: 50%;
      transform: translateX(-50%) scale(0.4);
    }
  }
`;

export default PreviewStyle;
